export default {
      id: "leg-right-usage",
      viewBox: "0 0 26 41",
      url: __webpack_public_path__ + "img/icons.ea6ea76b.svg#leg-right",
      toString: function () {
        return this.url;
      }
    }